import { z } from 'zod';

// Buckets are statusless task containers within a project (e.g. retainer
// periods, themes) — no lifecycle status, archive only.
export const TaskBucketSchema = z.object({
  id: z.string().uuid(),
  organizationId: z.string().uuid(),
  projectId: z.string().uuid(),
  name: z.string(),
  description: z.string().nullable().optional(),
  color: z.string().nullable().optional(),
  startDate: z.date().nullable().optional(),
  endDate: z.date().nullable().optional(),
  order: z.string().default("a1"),
  isArchived: z.boolean().default(false),
  settings: z.any().default({}),
  createdAt: z.date(),
  updatedAt: z.date(),
});

export type TaskBucket = z.infer<typeof TaskBucketSchema>;

// Create bucket schema
export const CreateTaskBucketSchema = TaskBucketSchema.omit({
  id: true,
  createdAt: true,
  updatedAt: true,
  settings: true,
}).extend({
  // Resolved from the request context server-side; clients never send it
  organizationId: z.string().uuid().optional(),
  settings: z.any().optional(),
});

export type CreateTaskBucket = z.infer<typeof CreateTaskBucketSchema>;

// Update bucket schema
export const UpdateTaskBucketSchema = TaskBucketSchema.omit({
  id: true,
  organizationId: true,
  projectId: true,
  createdAt: true,
  updatedAt: true,
}).partial();

export type UpdateTaskBucket = z.infer<typeof UpdateTaskBucketSchema>;

// Bucket with tasks schema
export const TaskBucketWithTasksSchema = TaskBucketSchema.extend({
  tasks: z.array(z.any()).optional(),
  taskCount: z.number().optional(),
  completedTaskCount: z.number().optional(),
});

export type TaskBucketWithTasks = z.infer<typeof TaskBucketWithTasksSchema>;
